// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import respondentsApi from '@/api/respondents';

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueScrollTo from 'vue-scrollto';
import ClipLoader from 'vue-spinner/src/ClipLoader';

import App from './App';
import store from './store';
import router from './router';
import i18n from './i18n';

Vue.config.productionTip = false;

Vue.component('clip-loader', ClipLoader);

Vue.use(BootstrapVue);

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Object.defineProperties(Vue.prototype, {
  $current_user: {
    get() {
      return respondentsApi.getRespondent();
    },
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  i18n,
  store,
});



// WEBPACK FOOTER //
// ./src/main.js